export const URL_FRONT = "https://www.symbiocenter.com/gestion/#/activites"; 
export const URL_FRONTLOCAL  = "http://localhost:8080/#/activites";
export const URL_API_SIRET =
  "https://api.insee.fr/entreprises/sirene/V3/siret/";
